/* ══════════════════════════════════════════════════════════════════════════
   "-up-to-date" file — installed 2026-09-29, replaces the Django-backed
   Team Breaks system for Live Breaks per Nathan's direction (a break is
   now a Shopify product, a team is a variant — no custom backend). The
   old Django system (card-vault.com) still exists and is untouched; the
   lane that used it on /pages/live-breaks-v2 was hidden, not removed —
   see sections/monmouth-live-breaks-new.liquid. The old, first-concept
   version of this idea is sections/monmouth-live-breaks.liquid +
   templates/page.live-breaks.json, both marked deprecated, kept for
   history only. This file and its sibling "-up-to-date" files are the
   current, real system.
   ══════════════════════════════════════════════════════════════════════════ */
/* ══════════════════════════════════════════════════════════════════════════
   MONMOUTH CARDS — LIVE BREAKS
   assets/monmouth-breaks-up-to-date.js
   ══════════════════════════════════════════════════════════════════════════
   Handles: team selection, the discount ladder preview, the cross-sell modal,
   random-spot quantity, index filtering, countdown, and adding to cart.

   DESIGN NOTES
   · Prices are never posted. The cart receives variant IDs and quantities
     only; Shopify prices the line and DealEasy applies the volume discount
     at checkout. The ladder on the page is a PREVIEW of that, nothing more.
   · Teams are variants, so availability is whatever Shopify says. There is
     no separate sold-out bookkeeping to drift out of sync.
   · Cross-sell reads a server-rendered JSON index, so it works on first
     paint with no extra request.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__mcBreaksInit) return;
  window.__mcBreaksInit = true;

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };

  /* ─────────────────────────────────────────────────────────────────────
     DISCOUNT — DealEasy volume model.
     ONE rate applies to every team in the cart, not a per-position ramp.
     Parsed from data-tiers so the theme editor is the single source.
     ───────────────────────────────────────────────────────────────────── */
  function parseTiers(str) {
    var out = [];
    (str || '1:0,2:2,3:3,4:4,5:5').split(',').forEach(function (pair) {
      var p = pair.split(':');
      var q = parseInt(p[0], 10), d = parseFloat(p[1]);
      if (!isNaN(q) && !isNaN(d)) out.push({ q: q, d: d });
    });
    return out.sort(function (a, b) { return a.q - b.q; });
  }
  function rateFor(tiers, qty) {
    var r = 0;
    tiers.forEach(function (t) { if (qty >= t.q) r = t.d; });
    return r;
  }

  /* ═══════════════════════ INDEX FILTERS ═══════════════════════
     Tag-driven (owner decision 2026-10-05): buttons come from the section setting `filter_tags`, matched against each
     card's data-tags ("|football|basketball|", already lowercase with _ and spaces turned into -). A tag button is only
     shown while at least one LOADED break carries the tag. One tag filter at a time; "Tonight" and "Spots left" are
     independent toggles that combine (AND) with it; "All breaks" clears everything. */
  (function initIndex() {
    var root = $('[data-breaks-index]');
    if (!root) return;
    var grid  = $('[data-grid]', root);
    var empty = $('[data-empty]', root);
    var bar   = $('[data-filters]', root);
    if (!grid || !bar) return;
    var state = { tag: '', tonight: false, open: false };

    function items() { return $$('.lb-grid-item', grid); }
    function hasTag(el, t) { return (el.getAttribute('data-tags') || '').indexOf('|' + t + '|') > -1; }

    function setPressed(btn, on) {
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    function refreshButtons() {
      var all = items();
      $$('[data-filter="tag"]', bar).forEach(function (btn) {
        var t = btn.getAttribute('data-tag'), n = 0;
        all.forEach(function (el) { if (hasTag(el, t)) n++; });
        var nEl = $('[data-n]', btn);
        if (nEl) nEl.textContent = n ? String(n) : '';
        btn.hidden = n === 0;
        if (n === 0 && state.tag === t) state.tag = '';
      });
    }

    function apply() {
      var shown = 0;
      items().forEach(function (el) {
        var ok = (!state.tag || hasTag(el, state.tag))
              && (!state.tonight || el.getAttribute('data-tonight') === '1')
              && (!state.open || el.getAttribute('data-open') === '1');
        el.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      setPressed($('[data-filter="all"]', bar), !state.tag && !state.tonight && !state.open);
      $$('[data-filter="tag"]', bar).forEach(function (b) { setPressed(b, state.tag !== '' && b.getAttribute('data-tag') === state.tag); });
      setPressed($('[data-filter="tonight"]', bar), state.tonight);
      setPressed($('[data-filter="open"]', bar), state.open);
    }

    function updateCount() {
      var c = $('[data-break-count]', root);
      if (c) c.textContent = String(items().length) + ($('[data-load-more]', root) ? '+' : '');
    }

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.lb-filter') : null;
      if (!btn || btn.hidden) return;
      var f = btn.getAttribute('data-filter');
      if (f === 'all') { state.tag = ''; state.tonight = false; state.open = false; }
      else if (f === 'tag') { var t = btn.getAttribute('data-tag'); state.tag = state.tag === t ? '' : t; }
      else if (f === 'tonight') { state.tonight = !state.tonight; }
      else if (f === 'open') { state.open = !state.open; }
      apply();
    });

    /* "Load more": products past the first 50 live on ?page=2, 3 … — fetch the next page, append its cards, rebuild the
       tag buttons/counts and re-apply the active filters. Without JS the link simply opens the next page. */
    root.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('[data-load-more]') : null;
      if (!link) return;
      e.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      var label = link.textContent; link.textContent = 'Loading\u2026';
      fetch(link.getAttribute('href'), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          $$('.lb-grid-item', doc).forEach(function (el) { grid.appendChild(document.importNode(el, true)); });
          var nextLink = $('[data-load-more]', doc);
          if (nextLink) { link.setAttribute('href', nextLink.getAttribute('href')); link.textContent = label; link.removeAttribute('aria-busy'); }
          else { var wrap = link.parentNode; if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap); }
          refreshButtons(); apply(); updateCount();
        })
        .catch(function () { link.textContent = label; link.removeAttribute('aria-busy'); });
    });

    refreshButtons(); apply(); updateCount();
  })();

  /* ═══════════════════════ BREAK DETAIL ═══════════════════════ */
  var root = $('[data-break-root]');
  if (!root) { initShared(); return; }

  var TIERS   = parseTiers(root.getAttribute('data-tiers'));
  var TYPE    = root.getAttribute('data-break-type');
  var sel     = {};   /* variantId -> {team, price, variant} */
  var randQty = 0;
  var randEl  = $('[data-random-spot]', root);
  var XSELL   = (function () {
    var el = $('[data-crosssell]', root);
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  })();

  function qty()   { return Object.keys(sel).length + randQty; }
  function gross() {
    var g = 0;
    Object.keys(sel).forEach(function (k) { g += sel[k].price; });
    if (randEl) g += randQty * parseInt(randEl.getAttribute('data-price'), 10);
    return g;
  }

  /* ── ladder preview ── */
  function renderLadder() {
    var box = $('[data-ladder]', root);
    if (!box) return;
    var q = qty(), cur = rateFor(TIERS, q);
    box.innerHTML = TIERS.map(function (t, i) {
      var isLast = i === TIERS.length - 1;
      var on = q >= t.q && cur === t.d;
      var label = isLast ? (t.q + '+ teams') : (t.q + (t.q === 1 ? ' team' : ' teams'));
      return '<div class="lb-rung' + (on ? ' is-on' : '') + '">' +
        '<div class="lb-rung-q">' + label + '</div>' +
        '<div class="lb-rung-p">' + (t.d ? t.d + '%' : '&mdash;') + '</div>' +
        '<div class="lb-rung-s">' + (t.d ? 'off every team' : 'full price') + '</div></div>';
    }).join('');
  }

  /* ── sticky cart bar ── */
  function renderBar() {
    var bar = $('[data-cart-bar]', root);
    if (!bar) return;
    var q = qty();
    bar.classList.toggle('is-on', q > 0);
    if (!q) return;

    var rate = rateFor(TIERS, q), g = gross(), d = g * rate / 100, next = rateFor(TIERS, q + 1);
    var parts = [];
    var teams = Object.keys(sel).length;
    if (teams)   parts.push(teams + ' team' + (teams > 1 ? 's' : ''));
    if (randQty) parts.push(randQty + ' random spot' + (randQty > 1 ? 's' : ''));

    $('[data-cart-line]', bar).innerHTML = parts.join(' + ') +
      (rate ? ' &middot; <b>' + rate + '% off every team</b>'
            : (next > rate ? ' &middot; add 1 more for <b>' + next + '% off</b>' : ''));
    $('[data-cart-total]', bar).innerHTML =
      (rate ? '<s>' + money(g) + '</s>' : '') + money(g - d) +
      (rate ? '<span class="lb-save">SAVE ' + money(d) + '</span>' : '');
  }

  function render() { renderLadder(); renderBar(); }

  /* ── team selection ── */
  $$('[data-team-board] .lb-team:not(.is-sold)', root).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant');
      if (sel[id]) {
        delete sel[id];
        btn.classList.remove('is-on');
        btn.setAttribute('aria-pressed', 'false');
        $('.lb-team-c', btn).textContent = '';
        render();
        return;
      }
      sel[id] = {
        variant: id,
        team: btn.getAttribute('data-team'),
        price: parseInt(btn.getAttribute('data-price'), 10)
      };
      btn.classList.add('is-on');
      btn.setAttribute('aria-pressed', 'true');
      $('.lb-team-c', btn).textContent = '\u2713';
      render();
      if (window.mcAnnounce) window.mcAnnounce(sel[id].team + ' added');
      crossSell(sel[id].team);
    });
  });

  /* ═══════════════════════ BOARD ENTRANCE (progressive enhancement) ═══════════════════════
     live-breaks-team-board-visual-polish-prompt.md — a one-time staggered fade/slide-in the
     first time "The Board" scrolls into view. Purely additive: it only ever ADDS the
     lb-teams--animate-in class the CSS keys off (see monmouth-breaks-up-to-date.css), never
     touches sel/render/classList on the team buttons themselves, and never runs at all if
     IntersectionObserver isn't available or the visitor has requested reduced motion — in
     every one of those cases the board simply has no animation rule to match and renders
     immediately in its normal, fully visible, fully clickable state. */
  (function () {
    var board = $('[data-team-board]', root);
    if (!board || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          board.classList.add('lb-teams--animate-in');
          io.disconnect();
        }
      });
    }, { threshold: 0.2 });
    io.observe(board);
  })();

  /* ── random spots ── */
  if (randEl) {
    var max = parseInt(randEl.getAttribute('data-max'), 10) || 0;
    var input = $('[data-qty-input]', randEl);
    $$('[data-qty]', randEl).forEach(function (b) {
      b.addEventListener('click', function () {
        var was = randQty;
        randQty = b.getAttribute('data-qty') === '+'
          ? Math.min(max, randQty + 1)
          : Math.max(0, randQty - 1);
        input.value = randQty;
        render();
        if (was === 0 && randQty === 1) crossSellRandom();
      });
    });
  }

  /* ═══════════════════════ CROSS-SELL ═══════════════════════
     Pick a team → offer the SAME team in other breaks. Same-release cases
     come first; other releases are the fallback. If the team is gone
     everywhere, recommend what's still open in this case instead. */
  var modalRows = [];

  function crossSell(team) {
    var open = XSELL.filter(function (x) { return x.team === team && !sel[x.variant]; });
    var same  = open.filter(function (x) { return x.sameRelease; });
    var other = open.filter(function (x) { return !x.sameRelease; });
    var use = same.length ? same : other;
    var cur = rateFor(TIERS, qty()), next = rateFor(TIERS, qty() + 1);
    var nudge = next > cur
      ? 'Add one more and your discount goes to <b>' + next + '% off every team</b> in your cart.'
      : 'You\u2019re at <b>' + cur + '% off every team</b> \u2014 the maximum.';

    if (use.length) {
      return openModal({
        eyebrow: same.length ? 'Same release, another case' : 'Also running',
        title: team + ' is open in ' + use.length + ' other break' + (use.length > 1 ? 's' : ''),
        sub: 'Each case is a separate break, so it\u2019s a separate shot at the same team.',
        nudge: nudge,
        rows: use.map(function (x) {
          return {
            title: x.sameRelease ? x.case : (x.release + ' \u2014 ' + x.case),
            sub: team + ' \u00b7 one spot at this price',
            price: x.priceText, variant: x.variant, url: x.url, external: true
          };
        }),
        all: 'Add ' + team + ' in all ' + use.length + ' \u2192'
      });
    }

    var left = $$('[data-team-board] .lb-team:not(.is-sold)', root)
      .filter(function (b) { return !sel[b.getAttribute('data-variant')]; })
      .sort(function (a, b) { return parseInt(b.getAttribute('data-price'), 10) - parseInt(a.getAttribute('data-price'), 10); })
      .slice(0, 3);
    if (!left.length) return;

    openModal({
      eyebrow: 'Only one left',
      title: team + ' is taken everywhere else',
      sub: 'You got the last ' + team + ' spot. Here\u2019s what else is open in this case.',
      nudge: nudge,
      rows: left.map(function (b) {
        return {
          title: b.getAttribute('data-team'),
          sub: 'Still open in this case',
          price: money(parseInt(b.getAttribute('data-price'), 10)),
          variant: b.getAttribute('data-variant'),
          local: b
        };
      }),
      all: 'Add all ' + left.length + ' \u2192'
    });
  }

  function crossSellRandom() {
    var picks = [];
    var seen = {};
    XSELL.forEach(function (x) {
      if (picks.length >= 3 || seen[x.productId] || !x.sameRelease) return;
      seen[x.productId] = 1;
      picks.push({
        title: x.team + ' \u2014 ' + x.case,
        sub: 'Guaranteed team instead of a draw',
        price: x.priceText, variant: x.variant, url: x.url, external: true
      });
    });
    if (!picks.length) return;
    var cur = rateFor(TIERS, qty()), next = rateFor(TIERS, qty() + 1);
    openModal({
      eyebrow: 'Want a guaranteed team too?',
      title: 'Lock a team in another case',
      sub: 'Random spots are drawn live. If there\u2019s a team you actually want, claim it outright.',
      nudge: next > cur
        ? 'Random spots count toward the ladder too \u2014 add one more for <b>' + next + '% off everything</b>.'
        : 'You\u2019re at <b>' + cur + '% off</b> \u2014 the maximum.',
      rows: picks,
      all: 'Add all ' + picks.length + ' \u2192'
    });
  }

  var modal = $('[data-modal]', root), overlay = $('[data-modal-overlay]', root);

  function openModal(cfg) {
    if (!modal) return;
    modalRows = cfg.rows;
    $('[data-modal-eyebrow]', modal).textContent = cfg.eyebrow;
    $('[data-modal-title]', modal).textContent = cfg.title;
    $('[data-modal-sub]', modal).textContent = cfg.sub;
    $('[data-modal-nudge]', modal).innerHTML = cfg.nudge;
    $('[data-modal-all]', modal).textContent = cfg.all;
    $('[data-modal-list]', modal).innerHTML = cfg.rows.map(function (r, i) {
      return '<div class="lb-xs"><div class="lb-xs-i"><div class="lb-xs-t">' + esc(r.title) + '</div>' +
        '<div class="lb-xs-s">' + esc(r.sub) + '</div></div><div class="lb-xs-p">' + r.price + '</div>' +
        '<button type="button" class="mc-btn mc-btn--primary mc-btn--sm" data-add="' + i + '">Add</button></div>';
    }).join('');
    $$('[data-add]', modal).forEach(function (b) {
      b.addEventListener('click', function () {
        addRow(modalRows[parseInt(b.getAttribute('data-add'), 10)]);
        b.textContent = '\u2713 Added';
        b.disabled = true;
        b.closest('.lb-xs').classList.add('is-on');
        render();
      });
    });
    modal.hidden = false;
    overlay.classList.add('is-on');
    requestAnimationFrame(function () { modal.classList.add('is-on'); });
  }

  function addRow(r) {
    if (!r) return;
    if (r.local) { r.local.click(); return; }   /* same board — reuse the toggle */
    sel[r.variant] = { variant: r.variant, team: r.title, price: parseInt(String(r.price).replace(/[^0-9]/g, ''), 10) };
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-on');
    overlay.classList.remove('is-on');
    setTimeout(function () { modal.hidden = true; }, 200);
  }
  $$('[data-modal-close]', root).forEach(function (b) { b.addEventListener('click', closeModal); });
  if (overlay) overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  var allBtn = $('[data-modal-all]', root);
  if (allBtn) allBtn.addEventListener('click', function () {
    modalRows.forEach(addRow); render(); closeModal();
  });

  /* ═══════════════════════ ADD TO CART ═══════════════════════
     Variant IDs and quantities only. Never a price. */
  var submit = $('[data-cart-submit]', root);
  if (submit) {
    submit.addEventListener('click', function () {
      var items = Object.keys(sel).map(function (k) {
        return { id: parseInt(k, 10), quantity: 1, properties: { 'Team': sel[k].team } };
      });
      if (randQty && randEl) {
        items.push({
          id: parseInt(randEl.getAttribute('data-variant'), 10),
          quantity: randQty,
          properties: { 'Team': 'Drawn live on air' }
        });
      }
      if (!items.length) return;

      var original = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart.'); });
          return r.json();
        })
        .then(function () {
          submit.textContent = '\u2713 Added';
          if (window.mcAnnounce) window.mcAnnounce(items.length + ' spots added to cart');
          document.dispatchEvent(new CustomEvent('mc:cart-updated'));
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (cart) {
            $$('.mc-nav__cart-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          }
          setTimeout(function () { window.location.href = '/cart'; }, 500);
        })
        .catch(function (err) {
          submit.disabled = false;
          submit.textContent = original;
          if (window.mcAnnounce) window.mcAnnounce(err.message);
          else alert(err.message);
        });
    });
  }

  render();
  initShared();

  /* ═══════════════════════ SHARED ═══════════════════════ */
  function initShared() {
    /* countdown */
    $$('[data-countdown]').forEach(function (el) {
      var target = parseInt(el.getAttribute('data-countdown'), 10) * 1000;
      var timer;
      function tick() {
        var d = Math.max(0, target - Date.now());
        var u = [['Days', Math.floor(d / 864e5)], ['Hours', Math.floor(d / 36e5) % 24],
                 ['Mins', Math.floor(d / 6e4) % 60], ['Secs', Math.floor(d / 1e3) % 60]];
        el.innerHTML = u.map(function (x) {
          return '<div class="lb-cd-u"><div class="lb-cd-n">' + String(x[1]).padStart(2, '0') +
                 '</div><div class="lb-cd-l">' + x[0] + '</div></div>';
        }).join('');
        if (d === 0) clearInterval(timer);
      }
      tick();
      timer = setInterval(tick, 1000);
      /* don't burn battery on a hidden tab */
      document.addEventListener('visibilitychange', function () {
        clearInterval(timer);
        if (!document.hidden) { tick(); timer = setInterval(tick, 1000); }
      });
    });

    /* FAQ accordions */
    $$('.lb-faq-q').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.parentNode, open = f.classList.toggle('is-on');
        b.setAttribute('aria-expanded', String(open));
        var i = $('.lb-faq-i', b);
        if (i) i.textContent = open ? '\u2212' : '+';
      });
    });

    /* smooth scroll triggers */
    $$('[data-scroll-to]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = document.getElementById(b.getAttribute('data-scroll-to'));
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
})();
